import {mapValues} from '@/utils/object';

const isPartArray = (part: object): boolean => {
  return 'type' in part && part.type === 'array';
};

const isPartGeneratedRepeat = (part: object): boolean => {
  return (
    '$generated' in part && !!part.$generated && typeof part.$generated === 'object' && '$repeat' in part.$generated
  );
};

export const recursiveReplaceIndex = <T>(value: T, index: number | string): T => {
  return recursiveReplace(value, /\{\$index\}/g, index.toString(), part => {
    return !part || isPartArray(part) || isPartGeneratedRepeat(part);
  });
};

export function recursiveReplace<T>(
  part: T,
  search: RegExp,
  replace: string,
  ignore: (part: unknown) => boolean = () => false,
): T {
  if (typeof part === 'string') {
    return part.replace(search, replace) as T;
  }

  if (Array.isArray(part)) {
    return part.map(value => recursiveReplace(value, search, replace, ignore)) as T;
  }

  if (typeof part === 'object') {
    if (ignore(part)) {
      return part;
    }

    return mapValues(part as Record<string, unknown>, value => recursiveReplace(value, search, replace, ignore)) as T;
  }

  return part;
}
